import React from 'react'

const Footer = () => {
  return (
    <>
      <div className="main-footer">
        <div data-test="footer">
          <p className="footer-content">
                            Copyright &copy; 2021 National Grid USA Service Company, Inc. All rights reserved.
          </p>
        </div>
      </div>
    </>
  )
}

export default Footer